// Anthology: vertical left-side thumbnail rail + prev/next arrow/swipe
// navigation for the main product image.
//
// Does NOT touch theme.ProductMediaGallery or the existing thumbnail click
// handler - it just re-triggers a real click on the thumbnail's prev/next
// sibling, so variant-driven image switching keeps working exactly as
// before. Also does NOT edit assets/theme.js.
//
// On desktop, the thumbnail rail is NOT a Slick carousel - theme.js still
// initializes it as its normal horizontal Slick carousel on load, but this
// script immediately unslicks it and lets it fall back to a plain vertical
// list (CSS just stacks the thumbnail <a> tags, which are display:block).
// All thumbnails show at once, capped to the main image's height and
// scrollable if there are more than fit. This avoids Slick's vertical-mode
// re-init timing/arrow-visibility issues entirely. Mobile is untouched -
// theme.js's default horizontal swipeable carousel stays exactly as-is.
(function ($) {
  function getThumbs($gallery) {
    return $gallery.find('.thumbnails .thumbnail');
  }

  function isQuickbuy($gallery) {
    return $gallery.closest('.quickbuy-container').length > 0;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function delistify($gallery) {
    var $thumbs = $gallery.find('.thumbnails');
    if (!$thumbs.length) return;
    if (getThumbs($gallery).length < 2) return; // only one image, nothing to list

    if (isDesktop()) {
      if ($thumbs.hasClass('slick-initialized')) {
        $thumbs.slick('unslick');
      }
    } else if (!$thumbs.hasClass('slick-initialized')) {
      // back below the breakpoint - restore theme.js's normal horizontal carousel
      $thumbs.slick({
        slidesToScroll: 1,
        variableWidth: true,
        infinite: false,
        speed: 200,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="' + (window.theme && theme.strings && theme.strings.previous || 'Previous') + '">' + ((window.theme && theme.icons && theme.icons.chevronLeft) || '') + '</button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="' + (window.theme && theme.strings && theme.strings.next || 'Next') + '">' + ((window.theme && theme.icons && theme.icons.chevronRight) || '') + '</button>'
      });
    }
  }

  // Cap the thumbnail rail's height to the main image's rendered height, so
  // it never grows taller than the photo it sits next to - it scrolls
  // internally instead if there are more thumbnails than fit.
  function syncThumbHeight($gallery) {
    var $thumbs = $gallery.find('.thumbnails');
    if (!$thumbs.length) return;

    if (!isDesktop()) {
      $thumbs.css('max-height', '');
      return;
    }

    var $main = $gallery.find('.main');
    var mainHeight = $main.outerHeight();
    if (mainHeight) {
      $thumbs.css('max-height', mainHeight + 'px');
    }
  }

  // Slide the outgoing image out and the incoming image in, horizontally,
  // similar to Jewlr's product gallery. Only animates simple images (video/
  // 3D model media just swap instantly, same as before) and degrades to a
  // plain instant swap if anything about the DOM isn't what's expected.
  function animateSlide($gallery, $oldMedia, $newMedia, direction) {
    if (!$oldMedia || !$oldMedia.length || !$newMedia || !$newMedia.length) return;
    if ($oldMedia.is($newMedia)) return;
    if ($oldMedia.data('media-type') !== 'image' || $newMedia.data('media-type') !== 'image') return;

    var $img = $oldMedia.find('img').first();
    var src = $img.length ? ($img[0].currentSrc || $img.attr('src')) : null;
    if (!src) return;

    var $main = $gallery.find('.main');

    // Cancel any transition already in progress, and tag this one with an
    // id so a late-firing cleanup from an older, overlapping slide can
    // never reach in and clear out a newer slide's state.
    var slideId = ($main.data('anthologySlideId') || 0) + 1;
    $main.data('anthologySlideId', slideId);
    clearTimeout($main.data('anthologySlideTimeout'));
    $main.find('.anthology-slide-ghost').remove();
    $main.find('.product-media').css({ transform: '', transition: '' });

    var $ghost = $('<div class="anthology-slide-ghost" aria-hidden="true"></div>').css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: 'url(' + src + ')',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      zIndex: 4,
      pointerEvents: 'none',
      transform: 'translateX(0)',
      transition: 'none'
    });
    $main.append($ghost);

    $newMedia.css({
      transform: 'translateX(' + (direction * 100) + '%)',
      transition: 'none'
    });

    // Force layout so the starting position above is committed before we
    // transition away from it - reading offsetWidth flushes pending style
    // changes, so the browser treats what follows as a change worth
    // animating instead of collapsing both states into one paint.
    void $ghost[0].offsetWidth;

    $ghost.css({ transition: 'transform 350ms ease', transform: 'translateX(' + (-direction * 100) + '%)' });
    $newMedia.css({ transition: 'transform 350ms ease', transform: 'translateX(0)' });

    function cleanup() {
      if ($main.data('anthologySlideId') !== slideId) return; // a newer slide already took over
      $ghost.remove();
      $newMedia.css({ transform: '', transition: '' });
    }

    $ghost.one('transitionend', cleanup);
    var timeoutId = setTimeout(cleanup, 450); // fallback in case transitionend never fires
    $main.data('anthologySlideTimeout', timeoutId);
  }

  function goTo($gallery, direction) {
    var $thumbs = getThumbs($gallery);
    if ($thumbs.length < 2) return;

    var $active = $thumbs.filter('.active');
    var index = $active.length ? $thumbs.index($active) : 0;
    var nextIndex = index + direction;

    if (nextIndex < 0) nextIndex = $thumbs.length - 1;
    if (nextIndex >= $thumbs.length) nextIndex = 0;

    var $targetThumb = $thumbs.eq(nextIndex);
    var oldMediaId = $active.length ? $active.data('media-id') : null;
    var $oldMedia = oldMediaId
      ? $gallery.find('.product-media[data-media-id="' + oldMediaId + '"]')
      : $gallery.find('.main .product-media:visible');

    $targetThumb.trigger('click');

    var $newMedia = $gallery.find('.product-media[data-media-id="' + $targetThumb.data('media-id') + '"]');
    animateSlide($gallery, $oldMedia, $newMedia, direction);
    setTimeout(function () { syncThumbHeight($gallery); }, 360);
  }

  function addArrows($gallery) {
    var $main = $gallery.find('.main');
    if (!$main.length || $main.find('.main-image-nav').length) return;
    if (getThumbs($gallery).length < 2) return; // nothing to navigate to

    var leftIcon = (window.theme && theme.icons && theme.icons.chevronLeft) || '&#8249;';
    var rightIcon = (window.theme && theme.icons && theme.icons.chevronRight) || '&#8250;';

    var $prev = $('<button type="button" class="main-image-nav main-image-nav--prev" aria-label="Previous image">' + leftIcon + '</button>');
    var $next = $('<button type="button" class="main-image-nav main-image-nav--next" aria-label="Next image">' + rightIcon + '</button>');

    $main.prepend($prev);
    $main.append($next);

    $prev.on('click', function (e) {
      e.preventDefault();
      goTo($gallery, -1);
    });
    $next.on('click', function (e) {
      e.preventDefault();
      goTo($gallery, 1);
    });

    // Basic touch swipe support on the main image
    var touchStartX = null;
    $main.on('touchstart', function (e) {
      touchStartX = e.originalEvent.touches[0].clientX;
    });
    $main.on('touchend', function (e) {
      if (touchStartX === null) return;
      var touchEndX = e.originalEvent.changedTouches[0].clientX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        goTo($gallery, delta < 0 ? 1 : -1);
      }
      touchStartX = null;
    });

    // Clicking a thumbnail directly (not via the arrows) also changes the
    // main image, and on a variant swap the image can change size too -
    // keep the rail's height cap in sync with whatever's now showing.
    $gallery.on('click', '.thumbnails .thumbnail', function () {
      setTimeout(function () { syncThumbHeight($gallery); }, 50);
    });
  }

  function initAll() {
    $('.product-gallery').each(function () {
      var $gallery = $(this);
      if (isQuickbuy($gallery)) return; // quickbuy keeps its own horizontal carousel
      delistify($gallery);
      syncThumbHeight($gallery);
      addArrows($gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  setInterval(initAll, 1500); // catch late-rendered/ajax-swapped galleries

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initAll, 150);
  });
})(jQuery);
